import Cookies from "./cookies";
import Events from "./events";
import Html from "./html";

class Weather {
    constructor(
        private html: Html,
        private cookies: Cookies,
        private events: Events
    ) { }

    /**
     * By default we write Ljubljana's weather info into
     * 24ur.com's top menu. If user has selected any other
     * city as his prefered weather city, let's fetch info
     * for that city and replace HTML in menu.
     */
    showCorrectWeather(): void {
        const city = this.cookies.get('weatherCity') || 'ljubljana';
        this.selectCity(city);
    }

    /**
     * Opens or closes popup for selecting weather city.
     * We don't have any HTML for this popup initially, we have to load
     * it the first time user wants to see it.
     */
    toggleCityPopup(selector: string): void {
        this.html.toggleClass(selector, 'hidden');

        // Load HTML from server if this is the first time we show this popup
        const isEmpty = !this.html.q(selector)?.innerHTML;
        if (isEmpty) {
            this.html.fetchText('/weather/city_popup')
                .then(html => {
                    this.html.writeHTML(selector, html);
                    this.updateUserCityName();

                    // HTML that is received from XHR ignores all onclick handlers. We
                    // have to manually add them.
                    this.html.qAll(selector + ' .weather-city-name')
                        .forEach(elt => {
                            const city = elt.dataset['city'] || '';
                            elt.addEventListener('click', () => this.selectCity(city, selector));
                        });
                });
        }
    }

    fetchWeather(selector: string, city: string, template = 'front_box'): Promise<any> {
        if (!city) {
            city = this.cookies.get('weatherCity') || 'ljubljana';
        }

        // Because of old angular site - we saved weather city as Žiri, not as keyword "ziri"
        const hasWrongChar = !!['%', ' ', 'š', 'č', 'ž', 'Š', 'Č', 'Ž'].find(c => city.includes(c));
        if (hasWrongChar) {
            city = 'ljubljana';
        }

        // Hack: don't load weather icon for ljubljana because ljubljana's
        // weather is already in HTML when we create it.
        if (city.toLowerCase() === 'ljubljana') {
            const cityName = this.html.getData('#menu_weather_icon', 'cityname')
            if (cityName === 'Ljubljana') {
                return Promise.resolve();
            }
        }

        return this.html.fetchText('/weather/' + city + '/' + template)
            .then(html => {
                this.html.writeHTML(selector, html);
            });
    }

    // This updates name of user's weather city in
    // the menu weather popup and on weather page.
    // City name is send in data-cityname="Ljubljana" html data attribute.
    updateUserCityName(): void {
        const cityName = this.html.getData('#menu_weather_icon', 'cityname')
        if (cityName) {
            this.html.writeHTML('.user_weather_cityname', cityName);
        }
    }

    selectCity(citySlug: string, citiesSelector: string | null = null): void {
        this.cookies.setIfImportantAllowed('weatherCity', citySlug);
        if (citiesSelector) {
            this.html.addClass(citiesSelector, 'hidden');
        }

        this.events.sendEvent('weather-city-selected', citySlug);
    }
}

export default Weather;